export default __webpack_public_path__ + "static/media/white-background.cc7938ce.jpeg";